export function getEmailDomain(email = '') {
  return email.split('@').pop();
}

export function getEmailUser(email = '') {
  return email.split('@').shift();
}
